// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2qJQI","label":"Completed_label__DrnfN"};